import { ApolloClient } from '@apollo/client';

export function registerQueryInterceptor(store, client, errorHandler) {
  client.query = async (options) => {
    try {
      const result = await ApolloClient.prototype.query.call(client, options);

      if (Object.prototype.hasOwnProperty.call(result, 'errors')) {
        throw result.errors;
      }

      return result;
    } catch (error) {
      return errorHandler(store, error);
    }
  };

  client.mutate = async (options) => {
    try {
      const result = await ApolloClient.prototype.mutate.call(client, options);

      if (Object.prototype.hasOwnProperty.call(result, 'errors')) {
        throw result.errors;
      }

      return result;
    } catch (error) {
      return errorHandler(store, error);
    }
  };
}
